<template>
    <Layout  :style="'min-height:'+ innerHeight + 'px'">
            <Header>
                <Menu mode="horizontal" theme="light" active-name="logout">
                    <div class="layout-logo">{{platInfo.name}}CRM</div>

                    <MenuItem name="logout">

                            <Dropdown  @on-click="logout">
                                <a href="javascript:void(0)" class="my-header-right">
                                    <img src="../../assets/3.png" />
                                    {{userInfo.name}}
                                </a>
                                <DropdownMenu slot="list">
                                    <DropdownItem name="pwd" >修改密码</DropdownItem>
                                    <DropdownItem name="logout" >退出</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                    </MenuItem>

                </Menu>
            </Header>
            <Layout>
                <Sider hide-trigger :style="{background: '#fff'}">
                    <Menu :active-name="String($route.name)" ref="menu" theme="light" width="auto" :open-names="openNames" >
                        <MenuItem name="index" to="/" >
<!--                            v-if="userInfo.role != 1 && userInfo.role != 4 && userInfo.role != 3 "-->
                            <!-- <Icon type="ios-navigate"></Icon> -->
                            <i class="iconfont icon-home" style="font-size:16px"></i>      
                            
                            首页
                        </MenuItem>
<!--                        " v-if="userInfo.role != 1 && userInfo.role != 4 "-->

                        <Submenu name="statistics" >
                            <template slot="title">
                            <i class="iconfont icon-piechart" style="font-size:16px"></i>                                
                                数据统计
                            </template>
                            <MenuItem name="statistics-index" to="/statistics/index" >队伍数据</MenuItem>
                            <MenuItem name="statistics-system" to="/statistics/system" >订单数据</MenuItem>
                        </Submenu>
<!--                        v-if="userInfo.role == 0  || userInfo.role == 2  ||  userInfo.role == 6 ||  userInfo.role == 5"-->
                        <MenuItem name="duesoon" to="/duesoon"  >                           
                            <i class="iconfont  icon-hourglass" style="font-size:16px"></i>   
                            即将到期
                        </MenuItem>
<!--                        v-if="userInfo.role == 0 ||  userInfo.role == 2 ||  userInfo.role == 6  ||  userInfo.role == 5"-->
                        <MenuItem name="customerpool-index" to="/customerpool/index" >
                            <i class="iconfont  icon-addteam" style="font-size:16px"></i>                               
                            客户池
                        </MenuItem>
<!--                        v-if="userInfo.role == 0  || userInfo.role == 2  ||  userInfo.role == 6 || userInfo.role == 5"-->
                        <MenuItem name="customerpool-retainage" to="/customerpool/retainage" >
                            <i class="iconfont  icon-meh" style="font-size:16px"></i>                            
                            尾款待付
                        </MenuItem>
<!--                        v-if="userInfo.role != 3"-->
                        <MenuItem name="aftersale" to="/aftersale" >
                            
                            <i class="iconfont  icon-smile" style="font-size:16px"></i>                            
                            待售后
                        </MenuItem>
<!--                        v-if="userInfo.role == 0 ||  userInfo.role == 3"-->
                        <MenuItem name="success-refund" to="/success/refund"   v-if="userInfo.role == 0" >
                            <i class="iconfont  icon-frown" style="font-size:16px"></i>   
                            
                            退款订单
                        </MenuItem>
                        <MenuItem name="success-index" to="/success/index"   v-if="userInfo.role == 0" >
                            <i class="iconfont  icon-fileprotect" style="font-size:16px"></i>                            
                            审核订单
                        </MenuItem>
<!--                        v-if="userInfo.role == 0 ||  userInfo.role == 2  ||  userInfo.role == 6  ||  userInfo.role == 5"-->
                        <MenuItem name="waters" to="/waters">
                            <i class="iconfont  icon-deploymentunit" style="font-size:16px"></i>                            
                            公海
                        </MenuItem>
                        <MenuItem name="history" to="/history" >
                            <i class="iconfont  icon-read" style="font-size:16px"></i>    
                            
                            历史订单
                        </MenuItem>
                        <Submenu name="company" v-if="userInfo.role == 0">
                            <template slot="title">
                                <i class="iconfont  icon-laptop" style="font-size:16px"></i>                                
                                公司管理
                            </template>
                            <MenuItem name="company-member" to="/company/member" >成员管理</MenuItem>
                            <MenuItem name="company-department" to="/company/department" >部门管理</MenuItem>
                            <MenuItem name="company-team" to="/company/team" >小组管理</MenuItem>
                            <MenuItem name="company-power" to="/company/power" >权限设置</MenuItem>
                        </Submenu>
                        <Submenu name="system" v-if="userInfo.role == 0 ">
                            <template slot="title">
                                <i class="iconfont  icon-setting" style="font-size:16px"></i>                                   
                               系统管理
                            </template>
                            <MenuItem name="system-tag" to="/system/tag" >标签管理</MenuItem>
                            <MenuItem name="system-industry" to="/system/industry" >行业管理</MenuItem>
                            <MenuItem name="system-customertype" to="/system/customertype" >客户类型</MenuItem>
                            <MenuItem name="system-transactiontype" to="/system/transactiontype" >成交方式</MenuItem>
                            <MenuItem name="system-dock" to="/system/dock" >对接方式</MenuItem>
                            <MenuItem name="system-config" to="/system/config" >企微配置</MenuItem>
                            <MenuItem name="system-orderproduct" to="/system/orderproduct" >所属系统</MenuItem>
                            <MenuItem name="system-customersource" to="/system/customersource" >客户来源</MenuItem>
                        </Submenu>

                    </Menu>
                </Sider>
                <Layout :style="{padding: '0 24px 24px'}">
                    <Content :style="{ minHeight: '280px'}">
                        <router-view></router-view>
                    </Content>
                </Layout>
                <Modal
                        :mask-closable="false"
                        v-model="show_modify_pwd"
                        title="修改密码"
                        width="400">
                    <div class="modal-title">密码</div>
                    <Input  placeholder="请填写密码" v-model="modifySubmit.pwd"  />
                    <div class="modal-title modal-title-two">再次</div>
                    <Input  placeholder="请再次填写密码" v-model="modifySubmit.againpwd"  />

                    <div slot="footer">
                        <Button  type="primary"  @click="modifypwd">确定</Button >
                    </div>
                </Modal>
            </Layout>
        </Layout>
</template>
<script>
    import {modify_data_pwd, logout} from '@/api/system'
import {windowsRise} from '@/utils/dom';
import {removeCookies} from '@/utils/helper'
    // import WebSocket from '@/utils/websocket';
export default {
    
    data(){
        return{
            innerHeight:0,
            openNames:[],
            userInfo:{},
            platInfo:{},
            modifySubmit:{
                pwd:""
            },
            show_modify_pwd:false
        }
    },


    metaInfo: {
        title:'首页',
        meta: [
            { name: 'viewport', content: 'width=device-width,user-scalable=yes,initial-scale=0.3,minimum-scale=0.3,maximum-scale=2' }
        ]
    },
    mounted(){
        this.restHeight();
        windowsRise(window, this.restHeight);
        this.selectMenu();
        this.userInfo = this.$store.state.userInfo
        this.platInfo = this.$store.state.platform

        let that = this
        // WebSocket.init();
        // WebSocket.tips = function (obj){
        //     that.$Notice.warning(obj);
        // }
        // this.$store.commit('setUserInfo', {id:1});
    },
     watch: {
        '$route.path'() {
            this.selectMenu();
        }
    },
    methods:{
        /**修改高度 */
        restHeight(){
            this.innerHeight =  window.innerHeight - 2;
        },
        /**修改导航展开样式 */
        selectMenu(){
            this.openNames = [this.$route.name.split('-')[0]];
            this.$nextTick(()=>{
                this.$refs.menu.updateOpened();
            })
        },
        logout(e){
            if (e == "logout") {
                this.logoutFun()
            } else if (e == "pwd"){
                this.show_modify_pwd = true;
            }
        },
        logoutFun(){
            logout().then(res=>{
                this.$router.push({path: '/login'});
                removeCookies('token');
            })
        },
        modifypwd(){
            if (this.modifySubmit.pwd == "") {
                this.$Message.error("密码不能为空");return;
            }
            if (this.modifySubmit.pwd != this.modifySubmit.againpwd) {
                this.$Message.error("两次输入的密码不一致");return;
            }
            modify_data_pwd({pwd:this.modifySubmit.pwd}).then(res=>{
                if(res.code == 200) {
                    this.show_modify_pwd = false;
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        }
    }

}
</script>

<style >
    body{
        color:#445E87FF!important;
    }
    .layout{
        border: 1px solid #d7dde4;
        background: #e4effa;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .ivu-layout{
        background: #e4effa !important;
    }
    .ivu-layout-header{
        background: #e4effa !important;
        padding:0!important;
        margin:10px  20px 10px!important;

    }
    .ivu-layout-header .ivu-menu-item-selected{
        border-bottom: none!important;
    }
    .ivu-layout-header .ivu-menu-horizontal{
        border-radius: 12px;
    }
    .ivu-menu-horizontal.ivu-menu-light:after{
        display: none!important;
    }
    .layout-logo{
        width: 300px;
        height: 30px;
        border-radius: 3px;
        float: left;
        position: relative;
        top: 15px;
        left: 30px;
        color:#3F8CFF;
        line-height: 30px;
        font-weight: bold;
        font-size: 26px;
    }


    .ivu-table-cell{
        padding:0 5px;
    }

    .my-white-mod tr td:nth-of-type(3) .ivu-table-cell{
        overflow: unset!important;
    }

    .ivu-menu-horizontal .ivu-menu-item{
      float:right!important;
    }
    .ivu-layout-sider{
        margin-left:20px;
        border-radius: 12px;
    }
    .ivu-menu-vertical.ivu-menu-light:after{
        display: none!important;
    }
    .ivu-layout-sider .ivu-menu{
        border-radius: 12px;
        padding-top:10px;
        color:#445E87;
    }
    .ivu-layout-sider .ivu-menu-item, .ivu-layout-sider .ivu-menu-submenu-title{
        margin:5px;
    }
    .ivu-layout-sider .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
        margin:5px;
        width:90%;
        border-radius: 12px;
    }
    .ivu-layout-sider .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu)::after{
        right:-8%;
        width:4px;
    }
    .my-white-mod{
        background: #ffffff;
        border-radius: 12px;
        width:100%;
        height:100%;
        padding:10px 20px;
        margin-top:10px;
    }
    .ivu-table:before{
        display: none!important;
    }
    .ivu-table th{
        background: #fff!important;
    }
    .ivu-table tbody tr:nth-of-type(odd) td{
        background: #F0F6FC;
    }
    .ivu-modal .ivu-modal-header, .ivu-modal .ivu-modal-footer{
        border:0
    }
    .ivu-modal .ivu-btn-text{
        display: none;
    }
    .ivu-modal .ivu-modal-confirm-footer .ivu-btn-text{
        display: unset!important;
    }
    .ivu-modal .ivu-modal-header-inner{
        font-size: 14px;
        color:#0A1629;
        font-weight: bold;
    }
    /*.ivu-modal .ivu-btn-primary{*/
    /*    border-radius: 8px;*/
    /*    font-size: 10px;*/
    /*    width: 70px;*/
    /*    height: 33px;*/
    /*    box-shadow: 0 6px 12px rgba(121, 145, 173, 0.2)*/
    /*}*/
    .ivu-modal .ivu-modal-close{
        overflow: unset!important;
    }
    .ivu-modal .modal-title{
        font-size:12px;margin-bottom: 10px;color:#445E87FF
    }
    .ivu-modal .modal-title-two{
        margin-top:15px
    }
    .ivu-modal .ivu-modal-close .ivu-icon-ios-close:before{
        content: "\eaf2";
        font-family: "iconfont" !important;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0A1629;
        font-size: 20px;
        background: #F4F9FD;
        border-radius: 12px;
        cursor: pointer;
    }
    .my-header-right{
        display: flex;
        align-items: center;
        justify-items: center;
        color:#0A1629FF;
    }
    .my-header-right img{
         width:30px;
        height:30px;
        border-radius: 50%;
        margin-right:10px;
     }
    .ivu-modal .my-modal-del{
        display: flex;align-items: center;text-align: center;justify-content:center
    }
    .ivu-modal .my-modal-del .ivu-icon-ios-alert{
        font-size:40px;color:#3F8CFFFF;
    }
    .ivu-alert-with-desc{
        position: absolute!important;
        z-index: 999;
        left: 50%;
        top: 60px;
        transform: translate(-50%,-50%);
    }
    .pointer {
        cursor: pointer;
    }

</style>
